module.exports = __webpack_public_path__ + "img/pin-icon.ac297166.svg";